<div nz-row nzJustify="center">
  <div nz-col nzSpan="15" class="container">
    <nz-skeleton
      [nzActive]="true"
      [nzParagraph]="{ rows: 10 }"
      [nzLoading]="(isLoading$ | async) ?? false"
    >
      <ng-container *ngIf="error$ | async as errorMsg; else result">
        <nz-result
          nzStatus="error"
          nzTitle="An error ocurred while fetching admins"
          [nzSubTitle]="errorMsg"
        ></nz-result>
      </ng-container>
    </nz-skeleton>
  </div>
</div>

<ng-template #result>
  <div nz-row nzJustify="space-between" nzAlign="bottom">
    <nz-table
      #adminTable
      [nzData]="(admins$ | async) ?? []"
      [nzShowPagination]="true"
      [nzShowSizeChanger]="true"
      [nzSize]="'small'"
      [nzPaginationPosition]="'both'"
      nz-col
      nzSpan="22"
    >
      <thead>
        <tr>
          <th>Username</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let admin of adminTable.data | sort: 'username'; trackBy: trackByRef">
          <td>
            {{ admin.username }}
          </td>
          <td nzAlign="right">
            <button
              nz-popconfirm
              nz-button
              nzIcon="delete"
              nzPopconfirmPlacement="left"
              nzOkText="Confirm delete"
              [nzLoading]="deleteLoading === admin.username"
              [nzPopconfirmTitle]="
                'Are you sure you want to delete ' + admin.username + ' as an admin?'
              "
              (nzOnConfirm)="deleteAdmin(admin.username)"
            >
              <i nz-icon nzType="delete" nzTheme="outline"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </nz-table>

    <div nz-col nzSpan="2">
      <div nz-row nzJustify="end">
        <button
          nz-button
          nzType="primary"
          nzShape="circle"
          nzSize="large"
          nz-tooltip
          nzTooltipTitle="Add new admin"
          (click)="createAdmin()"
        >
          <span nz-icon nzType="plus"></span>
        </button>
      </div>
    </div>
  </div>
</ng-template>
